import { CandidateGridCustomTooltip } from '@AMIEWEB/GlobalSearch/Candidate/SearchUtils';
import { ChannelType } from '@AMIEWEB/Notification/Constants';
import { XGridContactHoverView } from 'app/components/Common/XGrid/cells/HoverViewRenderers/XGridContactHoverView';
import { XGridBlueCell } from 'app/components/Common/XGrid/cells/XGridBlueCell';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { XGridLinkCell } from 'app/components/Common/XGrid/cells/XGridLinkCell';
import { XGridOverflowCell } from 'app/components/Common/XGrid/cells/XGridOverflowCell';
import { XGridSideBarViewCell } from 'app/components/Common/XGrid/cells/XGridSideBarViewCell';
import React from 'react';

const CandidateDefaultCell = {
  ...XGridDefaultColumn,
  flex: 0,
};

export const candidateViewInfo = (t, candidateCommunicationConsentFlag, leadsManagementEnabled = false) =>
  [
    {
      ...CandidateDefaultCell,
      field: 'candidateId',
      headerName: t('search.globalSearch.candidate.gridTags.cid'),
      width: 100,
      hide: false,
      renderCell: XGridOverflowCell(XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId'], true))(
        XGridSideBarViewCell('/candidate/{0}/{1}', ['candidateId', 'brandId']),
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'candidate',
      headerName: t('search.globalSearch.candidate.gridTags.candidate'),
      hide: false,
      width: 150,
      renderCell: XGridOverflowCell(XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId'], true))(
        XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId']),
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'firstName',
      headerName: t('search.globalSearch.candidate.gridTags.firstName'),
      hide: false,
      width: 150,
      renderCell: XGridOverflowCell(XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId'], true))(
        XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId']),
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'lastName',
      hide: false,
      headerName: t('search.globalSearch.candidate.gridTags.lastName'),
      width: 150,
      renderCell: XGridOverflowCell(XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId'], true))(
        XGridLinkCell('/candidate/{0}/{1}', ['candidateId', 'brandId']),
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'goesBy',
      hide: false,
      headerName: t('search.globalSearch.candidate.gridTags.goesBy'),
      width: 160,
    },
    {
      ...CandidateDefaultCell,
      field: 'otherName',
      hide: false,
      headerName: t('search.globalSearch.candidate.gridTags.otherNames'),
      width: 160,
    },
    {
      ...CandidateDefaultCell,
      field: 'phones',
      headerName: t('search.globalSearch.candidate.gridTags.phone'),
      sortable: false,
      width: 100,
      valueFormatter: param =>
        param.value.length === 0
          ? '--'
          : param.value
              .filter(x => x.phoneNumber !== null && x.phoneNumber !== undefined && x.phoneNumber.length > 0)
              .map(obj => `${obj.phoneTypeDescription}: ${obj.phoneNumber}`)
              .join(', '),
      renderCell: params => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <CandidateGridCustomTooltip
            value={params.value}
            candidate={params.row}
            type={ChannelType.voice}
            communicationConsentFlag={candidateCommunicationConsentFlag}
          />
          <CandidateGridCustomTooltip
            value={params.value}
            candidate={params.row}
            type={ChannelType.sms}
            communicationConsentFlag={candidateCommunicationConsentFlag}
          />
        </div>
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'emails',
      headerName: t('search.globalSearch.candidate.gridTags.email'),
      sortable: false,
      width: 100,
      valueFormatter: param =>
        param.value.primaryEmail || param.value.secondaryEmail
          ? Object.values(param.value)
              .filter(value => value)
              .join(', ')
          : '--',
      renderCell: params => (
        <CandidateGridCustomTooltip
          value={params.value}
          candidate={params.row}
          type={ChannelType.email}
          communicationConsentFlag={candidateCommunicationConsentFlag}
        />
      ),
    },
    {
      ...CandidateDefaultCell,
      field: 'skillsets',
      headerName: t('search.globalSearch.candidate.gridTags.skillSet'),
      hide: false,
      width: 160,
    },
    {
      ...CandidateDefaultCell,
      field: 'unverifiedSkillsets',
      headerName: t('search.globalSearch.candidate.gridTags.unVerifiedSkillset'),
      hide: false,
      width: 160,
    },
    {
      ...CandidateDefaultCell,
      field: 'brand',
      headerName: t('search.globalSearch.candidate.gridTags.brand'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'candidateStatus',
      headerName: t('search.globalSearch.candidate.gridTags.candidateStatus'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'recruiter',
      headerName: t('search.globalSearch.candidate.gridTags.recruiter'),
      hide: false,
      width: 150,
      renderCell: XGridOverflowCell(XGridContactHoverView('recruiterAttributes'), true)(XGridBlueCell),
    },
    {
      ...CandidateDefaultCell,
      field: 'activePlacement',
      headerName: t('search.globalSearch.candidate.gridTags.activePlacement'),
      hide: false,
      sortable: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'licensed',
      headerName: t('search.globalSearch.candidate.gridTags.licensed'),
      hide: false,
      sortable: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'availableToStartDate',
      headerName: t('search.globalSearch.candidate.gridTags.availableToStartDate'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'lastContactedOnDate',
      headerName: t('search.globalSearch.candidate.gridTags.lastContactedOnDate'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'callBackDate',
      headerName: t('search.globalSearch.candidate.gridTags.callBackDate'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'applicationDate',
      headerName: t('search.globalSearch.candidate.gridTags.applicationDate'),
      hide: false,
      width: 170,
    },
    {
      ...CandidateDefaultCell,
      field: 'city',
      headerName: t('search.globalSearch.candidate.gridTags.city'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'state',
      headerName: t('search.globalSearch.candidate.gridTags.state'),
      hide: false,
      width: 150,
    },
    {
      ...CandidateDefaultCell,
      field: 'lastPlacementEndDate',
      headerName: t('search.globalSearch.candidate.gridTags.lastPlacementEndDate'),
      width: 185,
      hide: false,
    },
    {
      ...CandidateDefaultCell,
      field: 'zipCode',
      headerName: t('search.globalSearch.candidate.gridTags.zip'),
      width: 150,
      hide: false,
    },
    {
      ...CandidateDefaultCell,
      field: 'distance',
      headerName: t('search.globalSearch.candidate.gridTags.radius'),
      width: 150,
      hide: false,
    },
    {
      ...CandidateDefaultCell,
      field: 'virtualInterview',
      headerName: t('search.globalSearch.candidate.gridTags.virtualInterview'),
      width: 150,
      hide: false,
    },
    {
      ...CandidateDefaultCell,
      field: 'covidVaxStatus',
      headerName: t('search.globalSearch.candidate.gridTags.covidVaxStatus'),
      width: 190,
      hide: false,
    },
    {
      ...CandidateDefaultCell,
      field: 'recruitingSpecialist',
      headerName: t('search.globalSearch.candidate.gridTags.recruitingSpecialist'),
      hide: false,
      width: 180,
      renderCell: XGridOverflowCell(XGridContactHoverView('recruitingSpecialistAttributes'), true)(XGridBlueCell),
    },
  ].filter(item => !(!leadsManagementEnabled && item.field === 'recruitingSpecialist'));
